import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { ServerService } from '../../../../ts/services/ServerService';
import { siteUserResetLoginRateLimiting } from '../../../actions/spaces/SiteUserMenuActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSelectingSomethingOtherThanGuest } from './IEntityActionHelpers';

export const SiteUserResetLoginRateLimitingAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserResetLoginRateLimiting,
  translateName: Messages.resetLoginRateLimiting_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    const serverService = ServiceLocator.get<ServerService>('ServerService');
    return FeatureFlags.localAuthLoginRateLimitingEnabled && serverService.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return isSelectingSomethingOtherThanGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserResetLoginRateLimiting(targetItems)
};
